import { FC, useEffect } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import {
    setPrerenderedCheckoutRootState,
    PRE_RENDER_STATE_ERROR,
} from '../../prerender/prerenderedCheckoutStore';
import {
    Error404Layout,
    error404RootQuery,
    error404RootQueryType,
} from 'dibs-buyer-layout/exports/error404';
import dibsCss from 'dibs-css';

export const Checkout404Page: FC = () => {
    useEffect(() => {
        setPrerenderedCheckoutRootState(PRE_RENDER_STATE_ERROR);
    }, []);
    const data = useLazyLoadQuery<error404RootQueryType>(error404RootQuery, {});

    return (
        <div className={dibsCss.mtLarge}>
            <Error404Layout viewer={data.viewer} />
        </div>
    );
};
